/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as AdminDefs from './defs.defs.js'
import * as RepoStrongRef from '../repo/strongRef.defs.js'

const $nsid = 'com.atproto.admin.getSubjectStatus'

export { $nsid }

/** Get the service-specific admin status of a subject (account, record, or blob). */
const main = l.query(
  $nsid,
  l.params({
    did: l.optional(l.string({ format: 'did' })),
    uri: l.optional(l.string({ format: 'at-uri' })),
    blob: l.optional(l.string({ format: 'cid' })),
  }),
  l.jsonPayload({
    subject: l.typedUnion(
      [
        l.typedRef<AdminDefs.RepoRef>((() => AdminDefs.repoRef) as any),
        l.typedRef<RepoStrongRef.Main>((() => RepoStrongRef.main) as any),
        l.typedRef<AdminDefs.RepoBlobRef>((() => AdminDefs.repoBlobRef) as any),
      ],
      false,
    ),
    takedown: l.optional(
      l.ref<AdminDefs.StatusAttr>((() => AdminDefs.statusAttr) as any),
    ),
    deactivated: l.optional(
      l.ref<AdminDefs.StatusAttr>((() => AdminDefs.statusAttr) as any),
    ),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
